import { Campaign2Service } from 'app/services/campaign-2.0/campaign2.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-monitor',
  templateUrl: './campaign-monitor.component.html',
  styleUrls: ['./campaign-monitor.component.css']
})
export class CampaignMonitorComponent implements OnInit {
  tableauView  = 'PoC/AnalisiCoupon';
  tableauViewUrl: string;
  showTableauView = false;

  constructor(
    private campaignService: Campaign2Service
  ) {

  }

  ngOnInit() {
    this.campaignService.getTableauData().subscribe(res => {
      this.tableauViewUrl = `${res.server_name}/trusted/${res.token}/t/${res.target_site}/views/${this.tableauView}`;
      //this.tableauViewUrl = `http://10.31.101.21/trusted/${res.token}/t/${res.target_site}/views/${this.tableauView}`;
      this.showTableauView = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-monitor/campaign-monitor.component.ts